import { Outlet, NavLink, Link, useLoaderData, Form, redirect, useNavigation, useSubmit, useLocation, } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Navbar, Drawer, Dropdown, Hero, Card, Menu } from 'react-daisyui'
import { ChevronDownIcon, Bars3Icon, EllipsisHorizontalIcon } from '@heroicons/react/24/outline'
import * as React from 'react'
import { useAuth } from "react-oidc-context";
import AuthEvents from "../AuthEvents";
import "../index.css"
//import { Button } from 'react-daisyui'

/*
export default (props) => {
  return <Button color="primary">Click me!</Button>
}
*/

export default function Root() {
  let location = useLocation();

  const auth = useAuth();

  const [authInitialising, setAuthInitialising] = React.useState(true);

  React.useEffect(() => {
    if (authInitialising && !auth.isLoading) {
      setAuthInitialising(false);
    }
  }, [auth.isLoading, authInitialising, setAuthInitialising]);


    /*
    const { contacts, q } : any = useLoaderData();
    const navigation = useNavigation();
    const submit = useSubmit();

    const searching =
    navigation.location &&
    new URLSearchParams(navigation.location.search).has(
      "q"
    );

    useEffect(() => {
      (document.getElementById("q") as HTMLInputElement).value = q;
    }, [q]);

    */
    const [visible, setVisible] = useState(false)

    React.useEffect(() => {
      setVisible(false)
    }, [location]);
    
    const toggleVisible = () => {
      setVisible(!visible)
    }

    const DrawerSide_old = (<ul className="menu p-4 w-80 bg-base-100 text-base-content">
    <li>
      <NavLink 
        to="/"
        id="DrawerHomeButton"
        className={({ isActive, isPending }) =>
          isPending ? "pending" : isActive ? "active" : ""
        }
        >
          Home
      </NavLink>
    </li>

    <div className="dropdown" id="DrawerStudiesDropdownButton">
      <label tabIndex={0} className="btn btn-ghost w-full normal-case font-normal text-base justify-start gap-2">Studies<ChevronDownIcon className="h-4 w-4"></ChevronDownIcon></label>
      <ul tabIndex={0} className="dropdown-content menu p-2 shadow bg-base-100 rounded-box w-52">
        <li>      
          <NavLink 
            to="studies"
            id="DrawerStudiesDropdownListStudiesButton"
            end
            className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "active" : ""
            }
            >
              List Studies
          </NavLink>
        </li>
        <li>          
          <NavLink 
            to="studies/create"
            id="DrawerStudiesDropdownNewStudyButton"
            className={({ isActive, isPending }) =>
              isPending ? "pending" : isActive ? "active" : ""
            }
            >
              New Study
          </NavLink>
        </li>
      </ul>
    </div>
  </ul>)

const DrawerSide = (
  <>
  <Menu className="menu mt-[55px] p-4 w-80 h-full bg-base-100 text-base-content" size="lg">
    
    <Menu.Item>
      <NavLink 
        to="/"
        id="DrawerHomeButton"
        className={({ isActive, isPending }) =>
          isPending ? "pending" : isActive ? "active" : ""
        }
      >
        Home
      </NavLink>
    </Menu.Item>
    <Menu.Item>
    <Menu.Details open={false} label={'Studies'} id="DrawerStudiesDropdownButton">
      <Menu.Item>
        <NavLink 
          to="studies"
          id="DrawerStudiesDropdownListStudiesButton"
          end
          className={({ isActive, isPending }) =>
            isPending ? "pending" : isActive ? "active" : ""
          }
        >
          List Studies
        </NavLink>
      </Menu.Item>
      <Menu.Item>
        <NavLink 
          to="studies/create"
          id="DrawerStudiesDropdownNewStudyButton"
          className={({ isActive, isPending }) =>
            isPending ? "pending" : isActive ? "active" : ""
          }
        >
          New Study
        </NavLink>
      </Menu.Item>
    </Menu.Details>
    </Menu.Item>
  </Menu>
  </>
)


    return (
      <>
        <AuthEvents />
        <Navbar >
        <Navbar.Start className="px-2 lg:flex-none">
          <div className="flex-none">
            <Button shape="square" color="ghost" id="ShowHideDrawerButton" onClick={toggleVisible}>
              <Bars3Icon className="w-8 h-8"/>
            </Button>
          </div>
          <div className="flex-1">
            <Button className="text-xl normal-case" color="ghost" id="TitleHomeButton">
              Life-Fit
            </Button>
          </div>
          </Navbar.Start>
      <Navbar.End> 
          <div className="flex-none mr-4">
            <Dropdown end={true} open={false}>
              <Dropdown.Toggle color="ghost" id="NavBarOptionsDropdownButton" className="btn btn-ghost btn-square" button={false}><EllipsisHorizontalIcon className="w-8 h-8" /></Dropdown.Toggle>
              <Dropdown.Menu className="w-52 z-10 text-lg">
                { auth.isAuthenticated ?
                  <Dropdown.Item
                    id="LogoutButton"
                    className=""
                    onClick={() => auth.revokeTokens(["access_token", "refresh_token"])
                    .then(() => auth.removeUser())}
                  >
                    Logout
                  </Dropdown.Item>
              : <Dropdown.Item
                  id="LogoutButton"
                  onClick={() => auth.signinRedirect({redirect_uri: `${window.location.origin}${location.pathname}`})}
                  >
                    Login
                  </Dropdown.Item>
              }
              </Dropdown.Menu>
          </Dropdown>
          </div>
          </Navbar.End>
        </Navbar>
        <Drawer className=" overflow-y-auto" open={visible} onClickOverlay={toggleVisible}
          id="DrawerMenu"
          overlayClassName="z-0" 
          contentClassName="z-0 h-[100vh] p-6 pb-[106px] overflow-y-auto"
          side={DrawerSide} 
        >    
         
            <Outlet/>
          
        </Drawer>
    
      </>
    );
  }